/**
 * useUrlOverrides()
 *
 * Persist cartId & providers query strings (if set) to urlOverrides state
 */
import { useEffect } from 'react';

import { useSearchParams } from 'react-router-dom';

import { CartsByCartId } from '@comicrelief/data-models/schemas/payments/models/Cart';
import { useAppDispatch } from '@/store/hooks';

import {
  setCartOverrideFromQuery,
  setProvidersOverrideFromQuery,
  setAmountOverrideFromQuery,
  setRowIdOverrideFromQuery,
  setClientOverrideFromQuery,
  setGivingTypeOverrideFromQuery,
  setAffiliateOverrideFromQuery,
  setSiteUrlOverrideFromQuery,
  setPopUpOverrideFromQuery,
  setDisableCartABTestOverrideFromQuery
} from './urlOverridesSlice';

export function useUrlOverrides(thisCartsData: CartsByCartId | undefined) {
  const dispatch = useAppDispatch();

  const [searchParams] = useSearchParams();

  useEffect(() => {
    // Needs to happen first in order to make it available to the A-B test functionality in the subsequent reducer:
    const disableABTestOverrideQuery = searchParams.get('disableABTest');
    if (disableABTestOverrideQuery) {
      dispatch(setDisableCartABTestOverrideFromQuery(disableABTestOverrideQuery));
    }

    const cartOverrideQuery = searchParams.get('cartId');
    if (cartOverrideQuery) {
      dispatch(setCartOverrideFromQuery({ cartID: cartOverrideQuery, cartsData: thisCartsData }));
    }

    const providersOverrideQuery = searchParams.get('providers');
    if (providersOverrideQuery) {
      dispatch(setProvidersOverrideFromQuery(providersOverrideQuery));
    }

    const clientOverrideQuery = searchParams.get('clientOverride');
    if (clientOverrideQuery) {
      dispatch(setClientOverrideFromQuery(clientOverrideQuery));
    }

    const amountOverrideQuery = searchParams.get('amount');
    if (amountOverrideQuery) {
      dispatch(setAmountOverrideFromQuery(amountOverrideQuery));
    }
    const givingTypeOverrideQuery = searchParams.get('givingType');
    if (givingTypeOverrideQuery) {
      dispatch(setGivingTypeOverrideFromQuery(givingTypeOverrideQuery));
    }

    const affiliateOverrideQuery = searchParams.get('affiliate');
    if (affiliateOverrideQuery) {
      dispatch(setAffiliateOverrideFromQuery(affiliateOverrideQuery));
    }

    const siteurlOverrideQuery = searchParams.get('siteurl');
    if (siteurlOverrideQuery) {
      dispatch(setSiteUrlOverrideFromQuery(siteurlOverrideQuery));
    }

    const rowIdOverrideQuery = searchParams.get('rowID');
    if (rowIdOverrideQuery) {
      dispatch(setRowIdOverrideFromQuery(rowIdOverrideQuery));
    }

    const popUpShownOverrideQuery = searchParams.get('popUpShown');
    if (popUpShownOverrideQuery) {
      dispatch(setPopUpOverrideFromQuery(popUpShownOverrideQuery));
    }
  }, [searchParams, dispatch, thisCartsData]);
}
